import { useRef } from 'react';
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

type Props = {
    files?: File[],
    onChange?: (files: any[], rawFiles: any[]) => void,
    multiple?: boolean,
    maxFiles?: number,
    server?: any,
    name?: string,
    label?: string,
 };

// Register the plugins
registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileRename,
    FilePondPluginImageResize,
    FilePondPluginImageTransform,
    FilePondPluginImageExifOrientation,
    FilePondPluginImageCrop,
);

const Upload: React.FC<Props> = ({ files, onChange, multiple, maxFiles, server, name, label }) => {
    const ref = useRef(null);

    const onUpdate = (files) => {
        if (onChange) {
            onChange(files, ref.current.getFiles());
        }
    }

    return (
        <FilePond
            ref={ref}
            files={files}
            onupdatefiles={onUpdate}
            allowMultiple={multiple}
            maxFiles={maxFiles}
            server={server}
            name={name}
            labelIdle={label}
            dropOnPage={true}
            stylePanelLayout={'compact circle'}
            credits={false}
            allowImageCrop={true}
            imageCropAspectRatio={'1:1'}
            allowImageResize={true}
            imageResizeTargetWidth={900}
            imageResizeUpscale={false}
            //allowFilePoster={true}
        />
    )
}

Upload.defaultProps = {
    files: [],
    maxFiles: 1,
    server: null,
    name: 'file',
    multiple: false,
    label: 'Drag & Drop your files or <span class="filepond--label-action">Browse</span>',
}

export default Upload;